export enum SectionLabels {
  STATS_HIGHLIGHTS = 'Statistic highlights',
  STATS_CARDS = 'Cards',
  STATS_OVERVIEW = 'Statistic overview',
  STATS_VIEWERS = 'Viewers statistics',
  ACTION_HISTORY = 'Action history'
}

export enum StatsCards {
  PROJECTS = 'Projects',
  AGREEMENTS = 'Agreements',
  PEOPLE = 'People',
  PRODUCTS = 'Products',
  STORES = 'Stores',
  USERS = 'Users'
}

export interface DashboardSectionSettings {
  visible: boolean
  position: number
}

export type LayoutSettings = {
  [key in SectionLabels]: DashboardSectionSettings
}
export type CardsSettings = {
  [key in StatsCards]?: DashboardSectionSettings
}

export const initialLayoutSettings: LayoutSettings = {
  [SectionLabels.STATS_HIGHLIGHTS]: { visible: true, position: 0 },
  [SectionLabels.STATS_CARDS]: { visible: true, position: 1 },
  [SectionLabels.STATS_OVERVIEW]: { visible: true, position: 2 },
  [SectionLabels.STATS_VIEWERS]: { visible: true, position: 3 },
  [SectionLabels.ACTION_HISTORY]: { visible: true, position: 4 }
}
